export default __webpack_public_path__ + "static/media/customer-preview.7d31389d.mp4";